





































import { Component, Vue, Prop, Watch } from 'nuxt-property-decorator'
import gql from 'graphql-tag'

@Component({
  name: 'buyConfirmationModal'
})
export default class extends Vue {
  @Prop() amount!: number

  formattedAmount = ''
  accountBalance: number = 0

  get userId() {
    return this.$store.state?.me?.id
  }

  @Watch('amount')
  onAmountChange() {
    this.formattedAmount = this.$n(this.amount, 'currency')
  }
}
